<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { usePromocodesApi } from '../api/list.hook'
import TablePromocodes from './TablePromocodes.vue'
import ModalCreatePromocode from './modals/ModalCreatePromocode.vue'
import ModalEditPromocode from './modals/ModalEditPromocode.vue'

defineOptions({
  name: 'PromocodesPage',
})

onMounted(() => {
  void usePromocodesApi()
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(() => {
  void usePromocodesApi()
})
</script>

<template>
  <TablePromocodes />
  <ModalCreatePromocode />
  <ModalEditPromocode />
</template>
